import Decimal from "decimal.js";

export class PrevisaoFinanceiraMovimentacao {
  static sincronizePorUnitario(item: any, valor: number): void {
    item._fonteCusto = 'unitario';
    item.custoUnitario = valor;
    const quantidade = Number(item.quantidade);
    item.custoTotal = quantidade > 0 && valor != null
      ? this.arredonde(quantidade * Number(valor))
      : null;
  }

  static sincronizePorTotal(item: any, valor: number): void {
    item._fonteCusto = 'total';
    item.custoTotal = valor;
    const quantidade = Number(item.quantidade);
    item.custoUnitario = quantidade > 0 && valor != null
      ? this.arredonde(Number(valor) / quantidade)
      : null;
    if(item.apresentacaoCompraInsumo && item.apresentacaoCompraInsumo.id){
      const quantidadeApresentacao = Number(item.quantidadeApresentacao);
      item.custoApresentacao = quantidadeApresentacao > 0 && valor != null
        ? this.arredonde(Number(valor) / quantidadeApresentacao)
        : null;
    }
  }

  static sincronizePorApresentacao(item: any, valor: number): void {
    item._fonteCusto = 'apresentacao';
    item.custoApresentacao = valor;
    item.custoUnitario = null;
    item.custoTotal = null;

    if(valor === null || valor === undefined)
      return;

    try {
      const custoApresentacao = new Decimal(valor);
      const quantidadeApresentacao = new Decimal(item.quantidadeApresentacao);
      const quantidadeBase = new Decimal(item.quantidade);
      if(!custoApresentacao.isFinite() || custoApresentacao.isNegative() ||
        !quantidadeApresentacao.isFinite() || quantidadeApresentacao.lessThanOrEqualTo(0) ||
        !quantidadeBase.isFinite() || quantidadeBase.lessThanOrEqualTo(0))
        return;

      const custoTotal = custoApresentacao.mul(quantidadeApresentacao)
        .toDecimalPlaces(6, Decimal.ROUND_HALF_UP);
      item.custoTotal = custoTotal.toNumber();
      item.custoUnitario = custoTotal.div(quantidadeBase)
        .toDecimalPlaces(6, Decimal.ROUND_HALF_UP)
        .toNumber();
    } catch (erro) {
      item.custoUnitario = null;
      item.custoTotal = null;
    }
  }

  static custoTotalPrevisto(item: any, tipo: string, beneficiamento: boolean): number | null {
    if(beneficiamento)
      return item.custoTotal == null ? null : Number(item.custoTotal);
    if(tipo === 'saida' || tipo === 'devolucao'){
      const custoMedio = this.custoMedioAtual(item);
      return custoMedio === null || !(Number(item.quantidade) > 0)
        ? null
        : this.arredonde(Math.abs(Number(item.quantidade)) * custoMedio);
    }
    if(item.custoTotal != null)
      return Number(item.custoTotal);
    return item.custoUnitario == null || !(Number(item.quantidade) > 0)
      ? null
      : this.arredonde(Number(item.quantidade) * Number(item.custoUnitario));
  }

  static prepareItemParaEnvio(item: any, tipo: string, beneficiamento: boolean): any {
    const seguro = Object.assign({}, item);
    delete seguro._fonteCusto;
    delete seguro.custoTotalPrevisto;
    delete seguro._apresentacoesCompra;
    delete seguro._carregandoApresentacoes;
    delete seguro._erroApresentacoes;
    delete seguro._erroConversaoApresentacao;
    delete seguro.custoApresentacao;
    if(beneficiamento || tipo === 'saida' || tipo === 'devolucao'){
      delete seguro.custoUnitario;
      delete seguro.custoTotal;
    } else if(item._fonteCusto === 'total' || item._fonteCusto === 'apresentacao') {
      delete seguro.custoUnitario;
    } else {
      delete seguro.custoTotal;
    }
    return seguro;
  }

  private static custoMedioAtual(item: any): number | null {
    const estoque = item.insumo && item.insumo.estoque;
    return !estoque || estoque.custoMedio === null || estoque.custoMedio === undefined
      ? null
      : Number(estoque.custoMedio);
  }

  private static arredonde(valor: number): number {
    return Number(Number(valor).toFixed(6));
  }
}
